import { render, staticRenderFns } from "./RecipeSidebar.vue?vue&type=template&id=7f26cc48&scoped=true&"
import script from "./RecipeSidebar.vue?vue&type=script&lang=js&"
export * from "./RecipeSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RecipeSidebar.vue?vue&type=style&index=0&id=7f26cc48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f26cc48",
  null
  
)

export default component.exports